import React, { useMemo } from 'react';
import SectionHeader from '../ui/SectionHeader';
import CarCard from '../features/CarCard';
import FadeIn from '../ui/FadeIn';
import { useVehicles } from '../../context/VehiclesContext';

const FeaturedCarsSection = ({ onViewDetails, onSeeAll }) => {
  const { vehicles: allVehicles } = useVehicles();

  const featured = useMemo(() => {
    const sorted = [...allVehicles].sort((a, b) => b.price - a.price);
    return sorted.slice(0, 6);
  }, [allVehicles]);

  return (
    <section className="featured-section" id="inventory">
      <div className="container">
        <FadeIn>
          <SectionHeader
            eyebrow="On the Forecourt"
            title="Featured Vehicles"
            subtitle="A handpicked spread from our current stock — updated as cars come and go"
          />
        </FadeIn>
        <div className="cars-grid">
          {featured.map((car) => (
            <FadeIn key={car.id}>
              <CarCard {...car} onViewDetails={() => onViewDetails && onViewDetails(car)} />
            </FadeIn>
          ))}
        </div>
        <div className="see-all-container">
          <button className="see-all-link" onClick={onSeeAll}>
            See all vehicles →
          </button>
        </div>
      </div>
    </section>
  );
};

export default FeaturedCarsSection;
